import { fromJS } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { setItem } from 'utils/localStorage';
import * as service from 'services/session.service';
import { LOGIN_REQUESTED, LOGIN_FAILED, LOGIN_SUCCESSFUL } from './LoginActionTypes';

export default function loginUser(username, password) { // eslint-disable-line
  let secondAttemptUserName = ''; // for second attempt login because of case sensitive username in userpools
  let count = 0;

    for(let i=0;i<username.length;i++) { // eslint-disable-line
      if (/[A-Z]/.test(username.charAt(i))) {
        count++; // eslint-disable-line
      }
    }

  if (count === 0) {
    secondAttemptUserName = username.charAt(0).toUpperCase() + username.slice(1);
  } else if (count > 0) {
    secondAttemptUserName = username.charAt(0).toLowerCase() + username.slice(1);
  }

  return (dispatch) => {
    dispatch({
      type: LOGIN_REQUESTED,
    });
    service.authenticateUser(username, password, (err, result) => {
      if (err) {
        service.authenticateUser(secondAttemptUserName, password, (secondError, secondResult) => {
          if (secondError) {
            dispatch({
              type: LOGIN_FAILED,
              error: {
                code: secondError.code,
                message: secondError.message,
              },
            });
          } else {
            const token = secondResult.session.idToken.jwtToken;
            setItem('isLoggedIn', true);
            setItem('token', token);
            window.sessionStorage.setItem('user', 'COACH');
                // end of dangerous code
            dispatch({
              type: LOGIN_SUCCESSFUL,
              session: fromJS(secondResult.session),
              user: fromJS(secondResult.user),
              attributes: fromJS(secondResult.attributes),
              token,
            });
          }
        });
      } else {
                // Storing token in to local storage
        const token = result.session.idToken.jwtToken;
        setItem('isLoggedIn', true);
        setItem('token', token);
        window.sessionStorage.setItem('user', 'COACH');
                // end of dangerous code
        dispatch({
          type: LOGIN_SUCCESSFUL,
          session: fromJS(result.session),
          user: fromJS(result.user),
          attributes: fromJS(result.attributes),
          token,
        });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/containers/Login/Login.actions.js